import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    confirmDialogCancel: string;
    confirmDialogConfirm: string;
    confirmDialogTitle: string;
    rescheduleDeletionDetails: (days: number) => string | React.ReactNode;
    toast: {
        error: (count: number) => string | React.ReactNode;
        pending: (count: number) => string | React.ReactNode;
        success: (count: number) => string | React.ReactNode;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            confirmDialogCancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useResetAssetsLifecycle.confirmDialogCancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            confirmDialogConfirm: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useResetAssetsLifecycle.confirmDialogConfirm?c=15tfx5mx8vyw0", defaultMessage: "Reset" }));
                },
                enumerable: true,
                configurable: true
            },
            confirmDialogTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useResetAssetsLifecycle.confirmDialogTitle?c=3txx5ptj03a4r", defaultMessage: "Reset Lifecycle?" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Body copy for reset lifecycle confirmation: days until auto-deletion */
            rescheduleDeletionDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (days: number) => __intl__.intl().formatMessage({ id: "useResetAssetsLifecycle.rescheduleDeletionDetails?c=1r8k1h11y2emv", defaultMessage: "This will reschedule these items to delete in {days, number} {days, plural, one {day} other {days}}." }, { days: days }));
                },
                enumerable: true,
                configurable: true
            },
            toast: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        error: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "useResetAssetsLifecycle.toast.error?c=1anb9ureei7ty", defaultMessage: "{count, plural, one {Failed to reset asset Lifecycle} other {Failed to reset assets Lifecycle}}" }, { count: count }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        pending: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "useResetAssetsLifecycle.toast.pending?c=1s6wn8pjyqxmf", defaultMessage: "{count, plural, one {Resetting asset Lifecycle...} other {Resetting assets Lifecycle...}}" }, { count: count }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        success: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "useResetAssetsLifecycle.toast.success?c=11fsvfpmknrw7", defaultMessage: "{count, plural, one {Asset Lifecycle has been reset} other {Assets Lifecycle has been reset}}" }, { count: count }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
